export const ICON = {
  AI_IMAGE: 'AiImage',
  ALERT: 'Alert',
  ALT_TEXT: 'AltText',
  ARROW: 'Arrow',
  ASCENDING: 'Ascending',
  BOLD: 'Bold',
  CALENDAR: 'Calendar',
  CANCEL: 'Cancel',
  CASH_DOWN: 'CashDown',
  CENTER: 'Center',
  CHART: 'Chart',
  CHECK: 'Check',
  CHEVRON: 'Chevron',
  CLOCK: 'Clock',
  CLOSE: 'Close',
  COMMUNITY: 'Community',
  COPY: 'Copy',
  CROP: 'Crop',
  DELETE: 'Delete',
  DESCENDING: 'Descending',
  DISCOUNT: 'Discount',
  DOWNLOAD: 'Download',
  EDIT: 'Edit',
  ELLIPSIS: 'Ellipsis',
  ENHANCE: 'Enhance',
  ERASE: 'Erase',
  EXPORT: 'Export',
  EXTERNAL_LINK: 'ExternalLink',
  EYE_SCAN: 'EyeScan',
  FILE: 'File',
  FILTER: 'Filter',
  FOLDER: 'Folder',
  FORM: 'Form',
  GRIP: 'Grip',
  HAND_COINS: 'HandCoins',
  HELP: 'Help',
  IMAGE: 'Image',
  IMAGE_TO_VIDEO: 'ImageToVideo',
  IMPORT: 'Import',
  INFO: 'Info',
  ITALIC: 'Italic',
  LANDSCAPE: 'Landscape',
  LAYERS: 'Layers',
  LEFT: 'Left',
  LIGHT_BULB: 'LightBulb',
  LINE_TROUGH: 'LineThrough',
  LINK: 'Link',
  LIST: 'List',
  LOCK: 'Lock',
  LOGOUT: 'Logout',
  MAGIC_WAND: 'MagicWand',
  MAGIC_WAND_ANIMATION: 'MagicWandAnimation',
  MERGE: 'Merge',
  MESSAGE: 'Message',
  MINUS: 'Minus',
  MOBILE_USE: 'MobileUse',
  MORE_ANIMATION: 'MoreAnimation',
  MOVE_DOWN: 'MoveDown',
  MOVE_UP: 'MoveUp',
  PERCENT: 'Percent',
  PLAY: 'Play',
  PLUS: 'Plus',
  PORTRAIT: 'Portrait',
  PRICE: 'Price',
  PROFILES: 'Profiles',
  PUBLISH: 'Publish',
  REFRESH: 'Refresh',
  REMOVE_BACKGROUND: 'RemoveBackground',
  REPLACE: 'Replace',
  RIGHT: 'Right',
  ROCKET: 'Rocket',
  SCHEDULE: 'Schedule',
  SEARCH: 'Search',
  SETTINGS: 'Settings',
  SIDEBAR: 'Sidebar',
  SPARKLE: 'Sparkle',
  SPARKLES: 'Sparkles',
  SQUARE: 'Square',
  STAGE: 'Stage',
  STAR: 'Star',
  STUDIO_LIGHT: 'StudioLight',
  SUCCESS: 'Success',
  TEXT: 'Text',
  TICKET_CHECK: 'TicketCheck',
  TREE_PALM: 'TreePalm',
  TRIAL: 'Trial',
  UNDERLINE: 'Underline',
  UNDO: 'Undo',
  UNLOCK: 'Unlock',
  UPLOAD: 'Upload',
  UPGRADE: 'Upgrade',
  USER: 'User',
  VIDEO: 'Video',
};
